import { Standard } from '@getvim/vim-connect';
import { orderA, orderB, orderC, orderG } from '../orders';
import { minnieMouse, natashaDavies, stevenVazquez } from '../patients';

export const predefinedPayloads: Record<string, Standard.Events.OrderCreatedPayload> = {
  'Minnie Mouse - Order A': {
    patient: minnieMouse as Standard.Events.TransformedPatientInContextPayload,
    order: orderA,
  },
  'Minnie Mouse - Order G': {
    patient: minnieMouse as Standard.Events.TransformedPatientInContextPayload,
    order: orderG,
  },
  'Steven Vazquez - Order B': {
    patient: stevenVazquez as Standard.Events.TransformedPatientInContextPayload,
    order: orderB,
  },
  'Natasha Davies - Order C': {
    patient: natashaDavies as Standard.Events.TransformedPatientInContextPayload,
    order: orderC,
  },
};
